// 🌗 Thème du site : clair ou sombre gardé dans « dark-mode » (App.js), ou « Automatique » (pied de
// page du nouveau design) : le site suit alors le réglage du navigateur ou du téléphone, à
// l'ouverture et quand il change. Un choix clair ou sombre, d'où qu'il vienne, quitte
// « Automatique ».
import { useEffect, useRef } from "react";

export const AUTO_KEY = "dark-mode-auto";
const DARK_QUERY = "(prefers-color-scheme: dark)";

export const systemTheme = () => {
  try {
    return window.matchMedia?.(DARK_QUERY).matches ? "dark" : "light";
  } catch {
    return "light";
  }
};

export const isAutoTheme = () => {
  try {
    return localStorage.getItem(AUTO_KEY) === "1";
  } catch {
    return false;
  }
};

export const setAutoTheme = (on) => {
  try {
    if (on) localStorage.setItem(AUTO_KEY, "1");
    else localStorage.removeItem(AUTO_KEY);
  } catch {
    // stockage indisponible (navigation privée) : le choix vaut pour cette page seulement
  }
};

// Thème affiché ("light" ou "dark") différent du navigateur alors qu'« Automatique » est gardé :
// l'utilisateur a choisi clair ou sombre, « Automatique » est quitté
export const keepAutoInSync = (mode) => {
  if (isAutoTheme() && mode !== systemTheme()) setAutoTheme(false);
};

// Première visite : aucun thème gardé à l'ouverture du site (ni « dark-mode » ni « Automatique »).
// À lire une seule fois au démarrage, avant que App.js n'enregistre son premier thème.
export const noStoredTheme = () => {
  try {
    return localStorage.getItem("dark-mode") === null && localStorage.getItem(AUTO_KEY) === null;
  } catch {
    return false;
  }
};

// 🌗 Première visite (tour 32) : le thème suit le navigateur (« Automatique »), une seule fois.
// Avant, App.js enregistrait « light » avant de lire le réglage et un navigateur en sombre recevait le
// thème clair.
export const useFirstVisitTheme = ({ firstVisit, setMode }) => {
  const done = useRef(false);
  useEffect(() => {
    if (!firstVisit || done.current) return;
    done.current = true;
    setAutoTheme(true);
    setMode(systemTheme());
  }, [firstVisit, setMode]);
};

// Le navigateur passe en clair ou en sombre : appelle onChange(thème) si « Automatique » est gardé
export const followSystemTheme = (onChange) => {
  let query;
  try {
    query = window.matchMedia?.(DARK_QUERY);
  } catch {
    query = null;
  }
  if (!query?.addEventListener) return () => {};
  const listener = () => isAutoTheme() && onChange(systemTheme());
  query.addEventListener("change", listener);
  return () => query.removeEventListener("change", listener);
};
